var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowReverseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54765 4.51079C6.74033 4.30597 7.061 4.30597 7.26041 4.51079C7.45308 4.70869 7.45308 5.03807 7.26041 5.23551L3.64632 8.94766H15.5723C15.8503 8.94812 16.0713 9.17508 16.0713 9.46063C16.0713 9.74618 15.8503 9.98052 15.5723 9.98052H3.64632L7.26041 13.6858C7.45308 13.8906 7.45308 14.2204 7.26041 14.4178C7.061 14.6227 6.73988 14.6227 6.54765 14.4178L2.07799 9.82691C1.87858 9.62901 1.87858 9.29963 2.07799 9.10219L6.54765 4.51079Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowReverseIcon);
export default __webpack_public_path__ + "static/media/arrow-reverse-icon.83f60fc0.svg";
export { ForwardRef as ReactComponent };